import { render, staticRenderFns } from "./ApplicationsCard.vue?vue&type=template&id=0a265a00&"
import script from "./ApplicationsCard.vue?vue&type=script&lang=js&"
export * from "./ApplicationsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports